import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_AUTH_MEMBER_REQUEST: '', // post
  GET_AUTH_MEMBER_SUCCESS: '',
  GET_AUTH_MEMBER_FAILURE: '',

  UPDATE_ADDRESS_PHONE_NUM_REQUEST: '',
  UPDATE_ADDRESS_PHONE_NUM_SUCCESS: '',
  UPDATE_ADDRESS_PHONE_NUM_FAILURE: '',

  VALIDATE_AUTH_REQUEST: '',
  VALIDATE_AUTH_SUCCESS: '',
  VALIDATE_AUTH_FAILURE: '',
};

types = setStoreTypeValues(types, 'authMember');

export default types;
